import { Link } from 'react-router-dom'
import { Globe, Home, ArrowLeft } from 'lucide-react'

const NotFound = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <div className="text-center space-y-6">
        <div className="relative">
          <div className="h-32 w-32 bg-sky-100 rounded-full flex items-center justify-center mx-auto">
            <Globe className="h-16 w-16 text-sky-600" />
          </div>
          <div className="absolute -bottom-2 -right-2 h-12 w-12 bg-amber-100 rounded-full flex items-center justify-center">
            <span className="text-2xl font-bold text-amber-600">?</span>
          </div>
        </div>

        <div>
          <h1 className="text-6xl font-bold text-slate-900">404</h1>
          <h2 className="text-2xl font-semibold text-slate-800 mt-2">Page Not Found</h2>
          <p className="text-slate-500 mt-2 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex items-center justify-center space-x-4">
          <button
            onClick={() => window.history.back()}
            className="flex items-center space-x-2 px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Go Back</span>
          </button>
          <Link
            to="/"
            className="flex items-center space-x-2 px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors"
          >
            <Home className="h-4 w-4" />
            <span>Dashboard</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
